import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import FeatureAccessGuard from './FeatureAccessGuard';
import { FEATURE_NAMES } from '../../apis/featureLimits';
import ScheduleForm from '../ScheduleForm';
import { FloatingUsageIndicator } from './FeatureUsageIndicator';
import { validateProfileComplete } from '../../utils/profileValidation';

// Wrapper component that adds feature limiting to Schedule Posts
const ScheduleFormWithLimits = () => {
  const navigate = useNavigate();

  // Check profile completion on component mount
  useEffect(() => {
    if (!validateProfileComplete({ showAlert: true, navigate })) {
      // Profile is incomplete - alert already shown by validateProfileComplete
      // If user clicks "Go to Profile Hub", they will be redirected
    }
  }, [navigate]);

  return (
    <FeatureAccessGuard 
      featureName={FEATURE_NAMES.SCHEDULE_DAYS}
      customMessage="Free users can schedule posts up to 7 days in advance. Subscribers can schedule up to 1 month in advance."
    >
      <FloatingUsageIndicator 
        featureName={FEATURE_NAMES.SCHEDULE_DAYS} 
        position="top-right" 
      />
      <ScheduleForm />
    </FeatureAccessGuard>
  );
};

export default ScheduleFormWithLimits;
